import React from 'react';

import { graphql } from 'gatsby';

import { NavigationData } from '../../../components/header/types';
import { SapFormData } from '../../dynamic-content-page/content-components/sap-form';
import { StrapiComponent } from '../../dynamic-content-page/live-preview/types';
import {
  isPageHeadline,
  PageHeadlineData,
  StrapiPageHeadline,
} from './page-headline';
import { isStageImage, StageImageData, StrapiStageImage } from './stage-image';
import { isStageVideo, StageVideoData, StrapiStageVideo } from './stage-video';

export const StrapiCampaignStageSectionFragment = graphql`
  fragment CampaignStageSectionFragment on STRAPI_CAMPAIGN_PAGE {
    stage {
      ...StageImageFragment
      ...StageVideoFragment
      ...PageHeadlineFragment
    }
  }
`;
export type PossibleStageComponents =
  | StageVideoData
  | PageHeadlineData
  | StageImageData
  | StrapiComponent;

type StrapiStageSectionProps = {
  langPrefix: string;
  navigationData: NavigationData;
  stage: PossibleStageComponents[];
  sapForm?: SapFormData | undefined;
};

export const StrapiStageSection = React.memo(
  ({ langPrefix, navigationData, stage, sapForm }: StrapiStageSectionProps) => {
    return stage.map((component: PossibleStageComponents, idx: number) => {
      if (isStageVideo(component)) {
        return <StrapiStageVideo key={idx} data={component} />;
      } else if (isPageHeadline(component)) {
        return (
          <StrapiPageHeadline
            key={idx}
            navigationData={navigationData}
            data={component}
            langPrefix={langPrefix}
            sapForm={sapForm}
          />
        );
      } else if (isStageImage(component)) {
        return <StrapiStageImage key={idx} data={component} />;
      } else {
        return null;
      }
    });
  },
);
